import { useSetRecoilState } from "recoil";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { himawariTypeState } from "../../../store/HimawariTypeState";

const HimawariDispatcher = (props) => {
  const setHimawariTypeInfo = useSetRecoilState(himawariTypeState);

  props.contents.setHimawariTypeInfoDispatcher((typeInfo) => {
    setHimawariTypeInfo(typeInfo);
  });

  return <WxContentsDispatcher {...props}/>
};

export default HimawariDispatcher;
